import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CountryService } from 'src/app/_services/country.service';
import { AdminService } from './../../../_services/admin.service';


@Component({
  selector: 'app-exam-format-new',
  templateUrl: './exam-format-new.component.html',
  styleUrls: ['./exam-format-new.component.css']
})
export class ExamFormatNewComponent implements OnInit {
  myForm:FormGroup
  loading=false
  server_exam_structure_id=0
  countryList=undefined
  isSaving=false
  errorSaving=false
  constructor(private adminService:AdminService, private router:Router, private activatedRoute:ActivatedRoute,private countryService:CountryService) { }

  ngOnInit(): void {
    this.loadCountries()
  }
  get f() {
    return this.myForm.controls
  }
  initMainFormUpdate(xxx:any){
    this.myForm=new FormGroup({
      countryId: new FormControl(xxx['server_country_id'], [Validators.required]),
      formalName: new FormControl(xxx['formalName'], [Validators.required]),
      totalMarks: new FormControl(xxx['totalMarks'], [Validators.required])
    });
  }
  initMainFormFresh(){
    this.myForm=new FormGroup({
      countryId: new FormControl("", [Validators.required]),
      formalName: new FormControl("", [Validators.required]),
      totalMarks: new FormControl(0, [Validators.required])
    });
  }

loadCountries(){
  this.loading=true
  this.countryService.getCountries().subscribe(
    x=>{
      this.countryList=x
      this.activatedRoute.params.subscribe(
        xx=>{
          this.server_exam_structure_id=xx['server_exam_structure_id']
          if(this.server_exam_structure_id!=0){
            this.adminService.getExamFormat(this.server_exam_structure_id).subscribe(
              xxx=>{
                this.initMainFormUpdate(xxx)
                this.loading=false
              }
            )
          }else{
            this.initMainFormFresh()
            this.loading=false
          }
        }
      )

    }
  )
}

on_submit(){
  this.isSaving=true
  let dd=this.formatData(this.myForm.value.countryId,this.myForm.value.formalName, this.myForm.value.totalMarks)
  if(this.server_exam_structure_id!=0){
    this.submitUpdate(dd)

  }else{
    this.submitInsert(dd)
  }

}
submitInsert(dd:string){
  this.adminService.newExamFormatItem(dd).subscribe(
    val=>{
      this.isSaving=false
      if(val['server_exam_structure_id']==0){
        this.errorSaving=true
      }
      else{
        this.router.navigate(['/admin/exam/structure/index'])
      }

    }
  )
}
submitUpdate(dd:string){
  this.adminService.updateExamFormatItem(dd,this.server_exam_structure_id).subscribe(
    val=>{
      this.isSaving=false
      if(val['server_exam_structure_id']==0){
        this.errorSaving=true
      }
      else{
        this.router.navigate(['/admin/exam/structure/index'])
      }

    }
  )
}
formatData(countryId:number, formalName:string,totalMarks:number){
  let data = new URLSearchParams();
  data.set('id',this.server_exam_structure_id.toString())
  data.set('country', countryId.toString());
  data.set('formalName', formalName);
  data.set('totalMarks', totalMarks.toString());
  return data.toString()
}
}
